import { Route } from 'AppShell/appshell_types';

const routes: Record<Route, string> = {
    ALICE_CART: '/cart/index/',
    ALICE_CHECKOUT: '/checkout/index/',
    CART: '/shop/cart',
    CART_NATIVE: '/app/shop/cart',
    CHECKOUT: '/shop/checkout',
    CHECKOUT_PAYMENT: '/secure/checkout/payment',
    CHECKOUT_NATIVE: '/app/shop/checkout',
    LOOKS_WISHLIST: '/web/wishlist',
    WISHLIST_NATIVE: '/app/wishlist',
    ASSEMBLYSERVICE: '/app/assemblyservice/overlay',
    SHIPPING_INFO: '/app/shipping/overlay',
    INTERIOR_DESIGN_SERVICE: '/m/westwingstudio',
    INTERIOR_DESIGN_SERVICE_NATIVE: '/app/m/westwingstudio',
    INTERIOR_DESIGN_SERVICE_OLD: '/m/interiorservice',
    HALLO_WELT: '/hallo-welt',
    LOOKS: '/looks',
    B2B: '/m/b2b',
    STYLES: '/styles', // obsolete path: every call to this path should lead to ALLPRODUCTS instead
    ALL_PRODUCTS: '/all-products',
    SERVICE_PAGE: '/service-page',
    OOPS_PAGE: '/not-found',
    LOGIN_AND_REGISTRATION: '/app/auth', // TODO[P100-3667]: only for dev/review, should be removed
    CLUB_MF_ROOT: '/c/',
    CLUB_MF_PRODUCT_DETAIL_PAGE: '/c/pdp/',
    CLUB_MF_UPCOMING_CAMPAIGN_PAGE: '/c/campaign/upcoming',
    CLUB_MF_SERVICE_PAGE: '/c/service-page',
    RESET_PASSWORD: '/password/reset/key/:resetKeyId',
} as const;

export default routes;
